import React, { Fragment, useState, useEffect, useCallback } from "react";
import api from "../../../components/helper/Api";
import { useTranslation } from "react-i18next";
import Image from "react-bootstrap/Image";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";
import { REDUX_LOCAL_STORE_KEY } from "../../../components/config/constants";
import Stories from "react-insta-stories";
import Loader from "../../../components/Loader.jsx";
import { X, Eye, VolumeX, Volume2, MoreHorizontal, Trash2, ThumbsUp } from "lucide-react";
import { getUserProfilePic } from "../../../components/helper/GeneralHelper";
import DefaultAvatar from "../../../components/common/DefaultAvatar.jsx";
import AccountVerifyTick from "../../../components/common/AccountVerifyTick.jsx";
import StoryService from "../../../services/StoryService";
import { MultiNumber } from "../../../components/common/MultiNumber.jsx";
import { useHistory, useLocation } from "react-router-dom";

const SingleStory = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const width = window.innerWidth;
  const isMobile = width <= 512;
  const isTab = width <= 9999;

  const searchParams = new URLSearchParams(location.search);

  const [state, setState] = useState({
    arrayStoryUrl: [""],
    currentCreator:
      (location.state?.currentCreator || 0) +
      (isMobile ? 0 : isTab ? 1 : 2),
    creatorDetails: JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY))
      .authentication.userData,
    storyId: searchParams.get("storyId"),
    isStoryMuted: false,
    showOption: false,
    story: null,
    storyLikeList: [],
    showModalTip: false,
    showModalReport: false,
    showModalDelete: false,
    showModalStatistics: false,
    doMessage: false,
  });

  const getStoryById = useCallback((id) => {
    api
      .getStoryById(id)
      .then((res) => {
        setState((prev) => ({ ...prev, story: res.data.data }));
      })
      .catch(() => {
        window.location.href = "/story-not-found";
      });
  }, []);

  useEffect(() => {
    getStoryById(state.storyId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Removed useless no-op event listeners that could never be properly cleaned up

  const muteAllVideos = useCallback((muted) => {
    const videoElements = document.getElementsByTagName("video");
    for (let i = 0; i < videoElements.length; i++) {
      videoElements[i].muted = muted;
    }
  }, []);

  const muteStory = useCallback(() => {
    setState((prev) => {
      const newMuted = !prev.isStoryMuted;
      setTimeout(() => muteAllVideos(newMuted), 0);
      return { ...prev, isStoryMuted: newMuted };
    });
  }, [muteAllVideos]);

  const getStoryLike = useCallback((storyId) => {
    let params = {
      storyId: storyId,
      page: 0,
      limit: 250,
    };
    StoryService.getStoryLike({ ...params })
      .then((res) => setState((prev) => ({ ...prev, storyLikeList: res.data.data[0].data })))
      .catch(() => {});
  }, []);

  const visualizeStory = useCallback(() => {
    let params = {
      storyId: state.storyId,
    };
    api
      .visualizeStory({ ...params })
      .then(() => {})
      .catch((err) => toast.error(err.message));
  }, [state.storyId]);

  const deleteStory = useCallback((storyId) => {
    let params = {
      storyId: storyId,
    };
    api
      .deleteStorie({ ...params })
      .then(() => {
        history.push("/");
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, [history]);

  const { story, creatorDetails } = state;

  return (
    <Fragment>
      {story && (
        <div
          onClick={() => {
            if (state.showOption === true) {
              setState((prev) => ({ ...prev, showOption: false }));
            }
          }}
          className="stories-page"
        >
          <div className="story-card-current flex-paginator">
            <span className="story-style">
              <span
                onClick={() =>
                  history.push(`/${creatorDetails?.userName}`)
                }
                style={{ position: "absolute" }}
                className=" hover story-creator-icon"
              >
                <div className="flex-paginator fix-story-icon pl-10px">
                  <span className="picture-story">
                    <DefaultAvatar
                      fontSize={"14px"}
                      width={"32px"}
                      height={"32px"}
                      userName={creatorDetails?.name}
                      id={creatorDetails?._id}
                    >
                      {creatorDetails?.profilePicture ? (
                        <Image
                          className="picture-story"
                          width={"32px"}
                          height={"32px"}
                          alt={creatorDetails?.name}
                          title={creatorDetails?.name}
                          src={getUserProfilePic(
                            creatorDetails?._id,
                            creatorDetails?.profilePicture
                          )}
                        ></Image>
                      ) : null}
                    </DefaultAvatar>
                  </span>
                  <span className="hover story-creators-name">
                    {creatorDetails?.name}{" "}
                    {creatorDetails?.isCreatorVerified ? (
                      <span
                        style={{
                          marginLeft: "2px",
                          verticalAlign: "text-bottom",
                        }}
                      >
                        <AccountVerifyTick width="15px"></AccountVerifyTick>
                      </span>
                    ) : null}
                  </span>
                </div>
              </span>
              <span className="fix-story-100-width">
                <Stories
                  isPaused={
                    state.showModalTip ||
                    state.showModalReport ||
                    state.showModalDelete
                  }
                  stories={[story.storyMedia.storyUrl]}
                  defaultInterval={15000}
                  width={
                    isMobile ? "100vw" : "calc(86.6666666vh * 0.560897)"
                  }
                  height={isMobile ? "100vh" : "86.6666666vh"}
                  loop={false}
                  onAllStoriesEnd={() => {}}
                  muted={state.isStoryMuted}
                  loader={<Loader />}
                  onStoryStart={() => {
                    visualizeStory();
                  }}
                  onStoryEnd={() => {
                    history.goBack();
                  }}
                  onNext={() => {
                    history.goBack();
                  }}
                  onPrevious={() => {
                    // history.goBack();
                  }}
                />
              </span>
              <div
                onClick={() => {
                  getStoryLike(state.storyId);
                  setState((prev) => ({ ...prev, showModalStatistics: true }));
                }}
                className="footer-story-extra hover"
                style={{ color: "white", zIndex: 999 }}
              >
                <div
                  className="d-flex justify-content-center align-items-center text-shadow-20px-black"
                  style={{ gap: "8px" }}
                >
                  <Eye size={18} />
                  <span className="f-14px-16px">
                    {t("archive.seeStatistics")}
                  </span>
                </div>
              </div>
            </span>
            <span
              onClick={() =>
                setState((prev) => ({
                  ...prev,
                  showOption: !prev.showOption,
                }))
              }
              className="story-option-button"
              name="no-close"
            >
              <MoreHorizontal size={20} />
              {state.showOption && (
                <div
                  name="no-close"
                  style={{ minHeight: "auto" }}
                  className="option-story-div pointer"
                >
                  {creatorDetails._id ===
                    JSON.parse(localStorage.getItem(REDUX_LOCAL_STORE_KEY))
                      .authentication.userData._id && (
                    <div
                      name="no-close "
                      className="d-flex justify-content-start align-items-center"
                      onClick={() => {
                        deleteStory(state.storyId);
                      }}
                    >
                      <Trash2
                        size={18}
                        style={{
                          position: "relative",
                        }}
                      />{" "}
                      {t("stories.delete")}
                    </div>
                  )}
                </div>
              )}
            </span>

            <span onClick={() => muteStory()} className="mute-button">
              {state.isStoryMuted === false ? (
                <Volume2 size={20} />
              ) : (
                <VolumeX size={20} />
              )}
            </span>

            {isMobile && (
              <span
                onClick={() => history.goBack()}
                className="close-story-button"
              >
                <X size={20} style={{ color: "white" }} />
              </span>
            )}
          </div>
        </div>
      )}
      {!isMobile && (
        <div className="close-story" style={{ zIndex: "99999" }}>
          <div
            onClick={() => {
              history.goBack();
            }}
            style={{ justifyContent: "center", gap: "7.24px" }}
            className="hover"
          >
            <X size={20} className="close-x" />
          </div>
        </div>
      )}
      {/* <Modal
                    show={state.showModalDelete}
                    onHide={() => setState(prev => ({ ...prev, showModalDelete: false }))}
                    keyboard={false}
                    centered
                >
                    <Modal.Header closeButton className="ps-3 pt-2 pb-2">
                        <span className="text-color-dark fw-700 font-xssss">
                            {t("stories.delete")}
                        </span>
                    </Modal.Header>
                    <Modal.Body
                        className={`p-4 add-card-modal ${state.doMessage === true ? "pb-0" : ""
                            }`}
                    >
                        <span className="text-color-dark fw-400 font-xssss">
                            {t("stories.deleteDescription")}
                        </span>
                    </Modal.Body>
                    <Modal.Footer className="d-flex p-2 justify-content-end">
                        <div
                            className="pointer fw-bold me-4 font-xsss text-silver"
                            onClick={() => setState(prev => ({ ...prev, showModalDelete: false }))}
                        >
                            {t("common.cancel")}
                        </div>
                        <Button
                            className="fix-tip-button fw-bold me-2 rounded-pill font-xssss text-white px-3 py-2 pointer"
                            onClick={() => {
                                deleteStory(
                                    state.storyList[state.currentCreator]?.stories[
                                        state.currentStory
                                    ]._id,
                                );
                            }}
                        >
                            {t("account.deleteAccount.modal.confirm")}
                        </Button>
                    </Modal.Footer>
                </Modal>
                <Modal
                    show={state.showModalStatistics}
                    onHide={() => setState(prev => ({ ...prev, showModalStatistics: false }))}
                    keyboard={false}
                    centered
                >
                    <Modal.Header closeButton className="ps-3 pt-2 pb-2">
                        <span className="text-color-dark fw-700 font-xssss">
                            {t("archive.storyStatistics")}
                        </span>
                    </Modal.Header>
                    <Modal.Body
                        className={`p-4 add-card-modal ${state.doMessage === true ? "pb-0" : ""
                            }
                          `}
                    >
                        <div>
                            <span className="text-12px">
                                {t("archive.totalView")}:{" "}
                            </span>
                            <span className="select-category-clip">
                                <MultiNumber
                                    numberToFix={
                                        story.storyTotalLikes
                                            ? story.storyTotalLikes
                                            : story.totalViews
                                    }
                                />{" "}
                                {t("archive.followers")}
                            </span>
                            <span className="text-12px" style={{ marginLeft: "16px" }}>
                                {t("archive.totalLkes")}:{" "}
                            </span>
                            <span className="select-category-clip">
                                <MultiNumber
                                    numberToFix={
                                        story.totalViews
                                            ? story.totalViews
                                            : story.storyTotalLikes
                                    }
                                />{" "}
                                {t("archive.followers")}
                            </span>
                        </div>
                        <Modal.Footer className="d-flex p-2 justify-content-end border-0"></Modal.Footer>
                    </Modal.Body>
                </Modal> */}
      <Modal
        show={state.showModalStatistics}
        onHide={() => setState((prev) => ({ ...prev, showModalStatistics: false }))}
        keyboard={false}
        centered
      >
        <Modal.Header closeButton className="ps-3 pt-2 pb-2">
          <span className="text-color-dark fw-700 font-xssss">
            {t("archive.storyStatistics")}
          </span>
        </Modal.Header>
        <Modal.Body
          className={`p-4 add-card-modal stats-modal ${
            state.doMessage === true ? "pb-0" : ""
          }
                          `}
        >
          <div>
            <span className="text-12px">
              {t("archive.totalView")}:{" "}
            </span>
            <span className="select-category-clip">
              <MultiNumber numberToFix={state.story?.totalViews || 0} />{" "}
              {t("archive.followers")}
            </span>
            <span className="text-12px" style={{ marginLeft: "16px" }}>
              {t("archive.totalLkes")}:{" "}
            </span>
            <span className="select-category-clip">
              <MultiNumber
                numberToFix={state.story?.storyTotalLikes || 0}
              />{" "}
              {t("archive.followers")}
            </span>
          </div>

          <div className="scroll-like-story">
            {state.storyLikeList?.length > 0 &&
              state.storyLikeList.map((value, index) => {
                return (
                  <div key={index} className="container-user-like-story flex-paginator align-center-only">
                    <span
                      style={
                        !value.userDetails?.profilePicture
                          ? { display: "flex" }
                          : {}
                      }
                    >
                      <DefaultAvatar
                        userName={value.userDetails?.name}
                        id={value.userDetails._id}
                        width={"48px"}
                        height={"48px"}
                        online={false}
                      >
                        {value.userDetails?.profilePicture ? (
                          <Image
                            style={{ borderRadius: "50px" }}
                            width={48}
                            height={48}
                            src={getUserProfilePic(
                              value.userDetails._id,
                              value.userDetails.profilePicture
                            )}
                          ></Image>
                        ) : null}
                      </DefaultAvatar>
                      <span className="user-like-thumbs">
                        <ThumbsUp size={18} />
                      </span>
                    </span>
                    <span>
                      <div className="name-user-story">
                        {value.userDetails.userName}
                      </div>
                      <div className="wallet-info">
                        @{value.userDetails.name}
                      </div>
                    </span>
                  </div>
                );
              })}
          </div>
          <Modal.Footer className="d-flex p-2 justify-content-end border-0"></Modal.Footer>
        </Modal.Body>
      </Modal>
    </Fragment>
  );
};

export default SingleStory;
